<script setup>
const model = defineModel();

const props = defineProps({
  min: {
    type: Number,
    default: 1
  },
  max: {
    type: Number,
    default: 99
  },
  limitMin: {
    type: Boolean,
    default: false
  },
  showTrash: {
    type: Boolean,
    default: false
  },
  showOnMobile: {
    type: Boolean,
    default: true
  },
  showOnDesktop: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['updateQuantity', 'removeLine'])
// const quantity = ref(props.initialQuantity)

const checkInput = (e) => {
  model.value = Math.min(props.max, Math.max(props.min, parseInt(e.target.value)))

  if (e.key === 'Enter') {
    emit('updateQuantity', model.value)
  }
}

const increment = () => {
  const newValue = Math.min(props.max, Math.max(props.min, model.value + 1))
  model.value = newValue
}

const decrement = () => {
  if (model.value === props.min && !props.limitMin) {
    model.value = 0
    emit('removeLine')
  } else {
    const newValue = Math.min(props.max, Math.max(props.min, model.value - 1))
    model.value = newValue
  }
}
</script>

<template>
  <div class="quantity-changer" :class="{ 'show-mobile' : showOnMobile, 'show-desktop' : showOnDesktop }">
    <button @click.stop.prevent="decrement" :disabled="limitMin && model <= min">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <rect
          width="24"
          height="24"
          fill="white"
          fill-opacity="0.01"
          style="mix-blend-mode: multiply"
        />
        <path
          v-if="showTrash && model <= 1"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
        />
        <path v-else d="M18 11.25H6V12.75H18V11.25Z" fill="currentColor" />
      </svg>
    </button>
    <input type="number" v-model="model" :min="min" :max="max" @input="checkInput" />
    <button @click.stop.prevent="increment" :disabled="model >= max">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <rect
          width="24"
          height="24"
          fill="white"
          fill-opacity="0.01"
          style="mix-blend-mode: multiply"
        />
        <path
          d="M12.75 11.25V6H11.25V11.25H6V12.75H11.25V18H12.75V12.75H18V11.25H12.75Z"
          fill="currentColor"
        />
      </svg>
    </button>
  </div>
</template>

<style lang="scss" scoped>
@use '@styles/sass_variables.scss' as *;

.quantity-changer {
  display: none;
  min-width: 124px;
  height: 48px;
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 100px;
  border: 1px solid var(--clr-gray-200);

  &.show-mobile {
    @media screen and (max-width: $breakpoint-medium) {
      display: inline-flex;
    }
  }

  &.show-desktop {
    @media screen and (min-width: $breakpoint-medium) {
      display: inline-flex;
    }
  }

  input {
    width: 30px;
    text-align: center;
    font-weight: 700;
    outline: none;
    -moz-appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  button:disabled {
    color: var(--clr-gray-300);
  }
}
</style>
